import c, { createContext as D, useState as a, useEffect as g, useMemo as f, useContext as E } from "react";
import { init as v, retrieveLaunchParams as y } from "@tma.js/sdk";
function r(t, e) {
  return (n) => {
    function o(s) {
      const l = {
        ...s,
        [t]: e()
      };
      return /* @__PURE__ */ c.createElement(n, { ...l });
    }
    return Object.defineProperty(o, "name", {
      value: `With${t[0].toUpperCase()}${t.slice(1)}`
    }), o;
  };
}
const u = D({
  loading: !1
});
u.displayName = "SDKContext";
function C({ options: t, children: e }) {
  const [n, o] = a(!1), [s, l] = a(), [h, S] = a();
  g(() => {
    o(!0), v({ ...t, complete: !0 }).then(S).catch(l).finally(() => o(!1));
  }, []);
  const B = f(() => {
    const p = { loading: n };
    return s && (p.error = s), h && (p.initResult = h), p;
  }, [n, h, s]);
  return /* @__PURE__ */ c.createElement(u.Provider, { value: B }, e);
}
function R({ options: t = {}, children: e }) {
  const n = f(() => {
    const o = { loading: !1 };
    try {
      o.initResult = v({ ...t, complete: !1 });
    } catch (s) {
      o.error = s;
    }
    return o;
  }, []);
  return /* @__PURE__ */ c.createElement(u.Provider, { value: n }, e);
}
function G(t) {
  const { options: e = {}, async: n } = t;
  return e.async || e.complete || n ? /* @__PURE__ */ c.createElement(C, { ...t }) : /* @__PURE__ */ c.createElement(R, { ...t });
}
function m() {
  return E(u);
}
function P(t) {
  const { initResult: e } = m();
  if (!e)
    throw new Error(`Unable to get init result key "${t}" as long as SDK is not initialized`);
  return e[t];
}
function w(t) {
  return Object.create(
    Object.getPrototypeOf(t),
    Object.getOwnPropertyDescriptors(t)
  );
}
function b(t) {
  const e = P(t), [n, o] = a(w(e));
  return g(() => e.on("change", () => {
    o(w(e));
  }), [e]), n;
}
function N(t) {
  return function(n) {
    const o = {
      ...n,
      sdk: m()
    };
    return /* @__PURE__ */ c.createElement(t, { ...o });
  };
}
function i(t, e) {
  return e ? () => b(t) : () => P(t);
}
const k = i("backButton", !0), J = r("backButton", k), x = i("closingBehavior", !0), X = r("closingBehavior", x), I = i("cloudStorage"), Y = r("cloudStorage", I), O = i("hapticFeedback"), Z = r("hapticFeedback", O), A = i("initData"), _ = r("initData", A), M = i("initDataRaw"), tt = r("initDataRaw", M), j = i("invoice", !0), et = r("invoice", j);
function F() {
  return f(y, []);
}
function nt(t) {
  return function(n) {
    return /* @__PURE__ */ c.createElement(t, { ...n, launchParams: F() });
  };
}
const H = i("mainButton", !0), ot = r("mainButton", H), K = i("miniApp", !0), rt = r("miniApp", K), L = i("popup", !0), it = r("popup", L), U = i("postEvent"), ct = r("postEvent", U), V = i("settingsButton", !0), st = r("settingsButton", V), W = i("qrScanner", !0), at = r("qrScanner", W), $ = i("themeParams", !0), ut = r("themeParams", $), q = i("utils"), lt = r("utils", q), Q = i("viewport", !0), ht = r("viewport", Q);
function d(t, e = {}) {
  return typeof t == "function" ? /* @__PURE__ */ c.createElement(t, { ...e }) : t;
}
function pt(t) {
  const { loading: e, initResult: n, error: o } = m();
  return n ? t.children : o ? d(t.error, { error: o }) : d(e ? t.loading : t.initial);
}
export {
  pt as DisplayGate,
  u as SDKContext,
  G as SDKProvider,
  k as useBackButton,
  x as useClosingBehavior,
  I as useCloudStorage,
  O as useHapticFeedback,
  A as useInitData,
  M as useInitDataRaw,
  j as useInvoice,
  F as useLaunchParams,
  H as useMainButton,
  K as useMiniApp,
  L as usePopup,
  U as usePostEvent,
  W as useQRScanner,
  m as useSDKContext,
  V as useSettingsButton,
  $ as useThemeParams,
  q as useUtils,
  Q as useViewport,
  J as withBackButton,
  X as withClosingBehavior,
  Y as withCloudStorage,
  Z as withHapticFeedback,
  _ as withInitData,
  tt as withInitDataRaw,
  et as withInvoice,
  nt as withLaunchParams,
  ot as withMainButton,
  rt as withMiniApp,
  it as withPopup,
  ct as withPostEvent,
  at as withQRScanner,
  N as withSDKContext,
  st as withSettingsButton,
  ut as withThemeParams,
  lt as withUtils,
  ht as withViewport
};
